import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'
import FunnelStepPage from './FunnelStepPage'
import { FUNNEL_STEPS } from './funnelSteps'

// li-funnel-redesign v1 — the same 31 screens as the baseline funnel, in the
// same order and at the same paths, rendered through the editorial archetypes.
const v1OnboardingRoutes = [
  {
    path: 'v1',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: FUNNEL_STEPS.map((step) => ({
      action: navigateToNextOnboardingPageAction,
      element: <FunnelStepPage step={step} />,
      path: step.path,
    })),
  },
]

export default v1OnboardingRoutes
